import cmer from "./cmer";
import bcko from "./bcko";
import channelProvider from "./channel-provider";
import closedMerchantCategory from "./closed-merchant-category";

export default {
  cmer,
  bcko,
  channelProvider,
  closedMerchantCategory,
};